import { Component, OnInit } from '@angular/core';
import { PageState } from '../../../../store/models/page.model';
import { Store } from '@ngrx/store';
import {
  openSnackbar,
  setBannerComponent,
} from '../../../../store/actions/page.action';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  Button,
  ButtonColor,
  ButtonSize,
} from '../../../../store/models/button.model';
import { AccountService } from '../../../../store/services/account.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  static readonly DEFAULT_SUCCESS_MESSAGE: string =
    'If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.';

  submitButtonProperties: Button = {
    text: 'Send Reset Password Instructions',
    color: ButtonColor.ORANGE,
    size: ButtonSize.BIG,
    onClick: () => this.onSubmit(),
  };

  formGroup: FormGroup;
  constructor(
    private readonly store$: Store<PageState>,
    private readonly accountService: AccountService
  ) {
    this.store$.dispatch(setBannerComponent({ banner: 'Forgot password' }));
  }

  ngOnInit(): void {
    this.formGroup = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  onSubmit() {
    if (!this.formGroup.valid) {
      this.formGroup.markAllAsTouched();
      return;
    }

    this.accountService
      .sendForgotPasswordEmail(this.formGroup.value.email)
      .subscribe(
        response => {
          if (response && response.success) {
            const message =
              response.message ||
              ForgotPasswordComponent.DEFAULT_SUCCESS_MESSAGE;
            this.store$.dispatch(
              openSnackbar({
                snackbarData: {
                  data: {
                    message,
                    type: 'success',
                  },
                },
              })
            );
          }
        },
        error =>
          this.store$.dispatch(
            openSnackbar({
              snackbarData: {
                data: {
                  message: error.error,
                  type: 'error',
                },
              },
            })
          )
      );
  }
}
